import styled from 'styled-components';
import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';

export const LinkWrapper = styled.div<{
  copied?: boolean;
  linkAsIcon: boolean;
}>`
  position: relative;
  display: flex;
  margin-right: ${({ linkAsIcon }) => !linkAsIcon && '1rem'};
  align-items: center;
  cursor: pointer;
  min-height: 40px;
  @media ${MEDIA_QUERIES.tablet} {
    padding: ${({ linkAsIcon }) => !linkAsIcon && '0.375rem 0.5rem'};
    border-width: ${({ linkAsIcon }) => !linkAsIcon && '1px'};
    border-style: dashed;
    border-color: ${({ copied, theme }) => (copied ? theme.colors.title : theme.colors.label)};
    border-radius: 4px;
    width: ${({ linkAsIcon }) => !linkAsIcon && '31.25rem'};
  }
`;
